import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

// import {Observable} from "rxjs/Observable";


@Injectable()
export class PhotoService extends ResourceService {
  constructor(authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.gallery.listUrl, ServiceConfig.gallery.detailUrl);
  }

  // getPhotos(galleryId: any): Observable<any> {
  //   return this.authorizedService.get(ServiceConfig.gallery.photosUrl.replace('{id}', galleryId))
  //     .map(response => response.json());
  // }
  //
  // getPhoto(galleryId: any, photoId: any): Observable<any> {
  //   return this.authorizedService.get(
  //     ServiceConfig.gallery.photoUrl.replace('{galleryId}', galleryId).replace('{photoId', photoId)
  //   )
  //     .map(response => response.json());
  // }
}



// WEBPACK FOOTER //
// ./src/services/photo.services.ts